
import { ProfessionData } from '../types/professionTypes';

export const construction: ProfessionData = {
  title: "Construction",
  slug: "construction",
  description: "Solutions de gestion des déchets du BTP et de la construction",
  icon: "HardHat",
  heroImage: "/lovable-uploads/328f4f86-9058-4b88-b6b8-5bcc727eb914.png",
  wasteMaterials: [
    {
      type: "Gravats et inertes",
      description: "Béton, briques, tuiles, pierres de démolition",
      solutions: ["Concassage mobile", "Criblage", "Réutilisation remblai"],
      environmentalBenefit: "Économie de ressources naturelles et réduction des transports"
    },
    {
      type: "Bois de construction",
      description: "Charpentes, coffrages, palettes, bois de démolition",
      solutions: ["Tri par essence", "Broyage", "Valorisation énergétique"],
      environmentalBenefit: "Évite l'incinération et produit de l'énergie renouvelable"
    },
    {
      type: "Métaux de construction",
      description: "Ferraille, cuivre, aluminium, aciers de structure",
      solutions: ["Tri magnétique", "Découpe", "Revente fonderies"],
      environmentalBenefit: "Réduction extraction minière et économie d'énergie"
    },
    {
      type: "Plâtre",
      description: "Cloisons, doublages, plâtre de démolition",
      solutions: ["Collecte sélective", "Recyclage plâtre", "Nouvelle production"],
      environmentalBenefit: "Économie de gypse naturel"
    }
  ],
  relatedProfessions: ["macon", "charpentier", "couvreur", "electricien"]
};
